import apiSlice from "../../features/apiSlice";
import { removeEmptyKeys } from "../../utils/helper";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRegion: builder.query({
      query: (queries) => {
        return {
          url: '/region',
          params: removeEmptyKeys(queries),
        };
      },
      providesTags:['Region']
    }),
    createRegion: builder.mutation({
      query: (credentials) => ({
        url: "/region",
        method: "POST",
        body: credentials,
      }),
      invalidatesTags:['Region']
    }),
    updateRegion: builder.mutation({
      query: (credentials) => ({
        url: `/region/${credentials.id}`,
        method: "PUT",
        body: credentials.body,
      }),
      invalidatesTags:['Region']
    }),
    bulkUpdateRegion: builder.mutation({
      query: (credentials) => ({
        url: `/region/updateMany`,
        method: "POST",
        body: credentials,
      }),
      invalidatesTags:['Region']
    }),
    deleteRegion: builder.mutation({
      query: (credentials) => ({
        url: `/region/${credentials.id}`,
        method: "DELETE",
      }),
      invalidatesTags:['Region']
    }),
    hardDeleteRegion: builder.mutation({
      query: (credentials) => ({
        url: `/region/hardDelete/${credentials.id}`,
        method: "DELETE",
        body: credentials.body,
      }),
      invalidatesTags:['Region']
    }),
  }),
});

export const {
  useGetRegionQuery,
  useCreateRegionMutation,
  useUpdateRegionMutation,
  useBulkUpdateRegionMutation,
  useDeleteRegionMutation,
  useHardDeleteRegionMutation
} = authApiSlice;
